import React from 'react';
import {
    Failed,
    SetupInstructions,
    SignIn,
    Success
} from '$ui/Integrations/Screens';
import GmailLogo from '$resources/gmail.svg';
import { Frame } from '$ui/Integrations/Frame';
import { SyncState } from '$types/integrations';
import {
    setup,
    SetupContext,
    useWorkflow
} from '$ui/Integrations/Workflows/workflows';
import { gmail as instructions } from '$ui/Integrations/instructions';

interface Props {
    auth: () => Promise<void>;
    sync: () => void;
    syncState: SyncState;
    onFinish: () => void;
}

// TODO: Refactor this when introducing a new integration
export const GmailSetup = ({ auth, sync, onFinish, syncState }: Props) => {
    const { matches, onSync, onSignIn, onNext, onBack, context } =
        useWorkflow<SetupContext>({
            healthyState: 'success',
            workflow: setup,
            syncState,
            auth,
            sync
        });

    const next = !['signIn', 'failed'].some(matches);
    const back = !matches('instructions');
    const last = matches('success');

    return (
        <Frame
            integration="Gmail"
            mode="Set up"
            next={next}
            back={back}
            last={last}
            onExit={onFinish}
            onNext={onNext}
            onFinish={onFinish}
            onBack={onBack}
        >
            {matches('instructions') && (
                <SetupInstructions
                    instructions={instructions}
                    integration="Gmail"
                    vimeoEmbedUrl="https://player.vimeo.com/video/768966345?h=40bfdbe736&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                />
            )}

            {matches('signIn') && (
                <SignIn
                    logo={GmailLogo}
                    integration="Gmail"
                    onSignIn={onSignIn}
                    signingIn={matches('signIn.signingIn')}
                />
            )}

            {matches('success') && (
                <Success
                    integration="Gmail"
                    onSync={onSync}
                    syncing={matches('success.syncing')}
                />
            )}

            {matches('failed') && (
                <Failed
                    integration="Gmail"
                    mode={context.failureMode}
                    onSignIn={onSignIn}
                    signingIn={matches('failed.signingIn')}
                />
            )}
        </Frame>
    );
};
